import React, { Component, Fragment } from 'react'
import Media from 'sb-media'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { connect } from 'redaction'
import { links, isNotEmpty } from 'common/helpers'

import Link from 'components/ui/Link/Link'
import Message from 'common/components/text/Message/Message'
import WidthContainer from 'components/_new/layout/widthContainer/WidthContainer/WidthContainer'

import s from './Breadcrumbs.scss'


class BreadcrumbsView extends Component {

  static propTypes = {
    rootLink: PropTypes.object,
    links: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
      ]),
      to: PropTypes.string,
      toOLD: PropTypes.string,
    })),
    withWidthContainer: PropTypes.bool,
  }

  renderContent() {
    const { links, rootLink } = this.props

    return (
      <Fragment>
        <Link className={s.link} styleless {...rootLink}>Scentbird</Link>
        <span className={s.arrow} />
        {
          isNotEmpty(links) && (
            links.map(({ title, to, toOLD }, index) => {
              const isLast = index === links.length - 1

              if (isLast) {
                return (
                  <Message
                    key={index}
                    className={s.currentPage}
                    text={title}
                    messageName="ui.Breadcrumbs"
                  />
                )
              }

              const props = {
                className: s.link,
                styleless: true,
                title,
                to,
                toOLD,
              }

              return (
                <Fragment key={index}>
                  <Link {...props} />
                  <span className={s.arrow} />
                </Fragment>
              )
            })
          )
        }
      </Fragment>
    )
  }

  render() {
    const { withWidthContainer } = this.props

    if (withWidthContainer) {
      return (
        <WidthContainer className={cx(s.container, s.isWidthContainer)}>
          {this.renderContent()}
        </WidthContainer>
      )
    }

    return (
      <div className={s.container}>
        {this.renderContent()}
      </div>
    )
  }
}


const Breadcrumbs = (props) => (
  <Media exceptMobile>
    <BreadcrumbsView {...props} />
  </Media>
)

Breadcrumbs.propTypes = BreadcrumbsView.propTypes


export default connect({
  rootLink: ({ models: { me: { gender, isLoggedIn } } }) => {
    const mainPageLink = gender === 'male' ? links.subscription.mainMen : links.subscription.mainWomen

    return isLoggedIn ? { to: mainPageLink } : { toOLD: links.home }
  },
  links: 'models.breadcrumbs',
})(Breadcrumbs)
